import React from 'react'
import NotFoundBlock from '../components/NotFoundBlock'
function Notfound() {
  return (
    <NotFoundBlock/>
  )
}

export default Notfound